export default __webpack_public_path__ + "static/media/MetalProduction_icon.6254c707.svg";